import React, { useState, memo } from 'react';
import TextTruncate from 'react-text-truncate';

// Components
import { WpTooltip, WpTooltipTrigger, WpTooltipContent } from '../tooltip';

type Props = {
  text: string;
  numberOfLines?: number;
  showTooltip?: boolean;
};

const WpTextTruncate = ({ text, numberOfLines = 2, showTooltip = false }: Props) => {
  const [isTruncated, setIsTruncated] = useState(false);

  const content = (
    <span style={{ width: '100%' }}>
      <TextTruncate line={numberOfLines} text={text} onToggled={setIsTruncated} />
    </span>
  );

  return showTooltip && isTruncated ? (
    <WpTooltip>
      <WpTooltipTrigger>{content}</WpTooltipTrigger>
      <WpTooltipContent>{text}</WpTooltipContent>
    </WpTooltip>
  ) : (
    content
  );
};

export default memo(WpTextTruncate);
